import React, { Component } from 'react';
import AdministratorsApi from '../../api/administrators';
import { withRouter } from '../../utils/withRouter';

class Reports extends Component {
    constructor(props) {
        super(props);
        this.state = {
            downloading: true
        };
    }
    async componentDidMount() {
        try {
            const query = this.props.location.search.split("=");
            await AdministratorsApi.downloadReport(query[1]);
            this.setState({ downloading: false });
        } catch(error) {
            alert("Could not download the file");
        }
    }

    render() {
        return (
            <section className="animated fadeIn">
                <div className="col-12">
                    { this.state.downloading ? "Your report is downloading" : "Your report has downloaded"}
                </div>
            </section>
        )
    }
}

export default withRouter(Reports);
